ACC.selectiveCartSplitList = {
    _autoload: ['saveItemSelection', 'removeItemSelection'],
    saveItemSelection() {
        $('.js-wishlist-select-item').click(function () {
            ACC.selectiveCartSplitList.submit($(this).parent(), $(this).data('checkurl'), $(this).data('productcode'));
        });
    },
    removeItemSelection() {
        $('.js-wishlist2-entry-action-remove-button').click(function () {
            ACC.selectiveCartSplitList.submit($(this).parent(), $(this).data('removeurl'), $(this).data('productcode'));
        });
    },
    submit(form, url, productCode) {
        form.append($('<input>').attr({ type: 'hidden', name: 'productCode' }).val(productCode));
        form.attr('action', url).submit();
    },
};
